<template>

    <div class="has-margin-top">
        <div class="bp-panel has-no-title" style="min-height: auto">
            <div class="panel-content">
                <div class="buttons has-addons mb-0">
                    <button
                        v-for="publication in publications"
                        :key="publication.website.key"
                        class="button homepage-select-button"
                        :class="{ 'is-primary': publication.website.key === selectedHomepage }"
                        :title="statusNames[getStatus(publication)]"
                        @click="$emit('buttonAction', {action: 'switchHomepage', element: publication.website.key})"
                    >
                        <span class="homepage-select-status" :class="'is-' + getStatus(publication)"></span>
                        {{ publication.website.name }}
                    </button>
                </div>
                <p class="is-small-text mt-2">
                    Veröffentlichen und Kategorie gelten nur für die gewählte Homepage. Texte, Bilder, Tage und Preise gelten für alle Homepages.
                </p>
            </div>
        </div>
    </div>

</template>

<script>

import Mixin from '../../tab';

export default {
    mixins: [ Mixin ],

    props: {
        component: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            statusNames: {
                notPublished: 'Nicht veröffentlicht',
                staged: 'Auf Testseite veröffentlicht',
                published: 'Veröffentlicht',
            },
        }
    },

    computed: {
        publications: function () {
            return this.component.props.publications;
        },

        selectedHomepage: function () {
            return this.component.props.selectedHomepage;
        },
    },

    methods: {
        // Stand auf der neuen Website, sonst auf der Webflow-Seite der Homepage
        getStatus(publication) {
            if(publication.website.active) {
                return publication.status;
            }
            const link = (this.item.webflowLinks || []).find(link => link.type === 'order' && link.webflowCollection && link.webflowCollection.webflowHomepage
                && link.webflowCollection.webflowHomepage.id === publication.website.webflowHomepageId);
            return link && link.status ? link.status : 'notPublished';
        },
    },
}
</script>
